/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  "'Goals.CreateGoal.footer.create-label": 'Criar',
  'Goals.CreateGoal.create.error': 'Não foi possível criar a meta',
  'Goals.CreateGoal.create.network.error': 'Falha na conexão',
  'Goals.CreateGoal.create.permission.error': 'Você não tem a permissão necessária para criar uma meta.',
  'Goals.CreateGoal.error.description': 'Algo deu errado, verifique sua conexão com a internet e tente de novo.',
  'Goals.CreateGoal.error.header': 'Não foi possível criar a meta',
  'Goals.CreateGoal.footer.cancel-label': 'Cancelar',
  'Goals.CreateGoal.form.icon.back-button-label': 'Voltar',
  'Goals.CreateGoal.form.name.error': 'Você deve adicionar um nome para a meta',
  'Goals.CreateGoal.form.name.label': 'Nome',
  'Goals.CreateGoal.form.owner.error': 'O proprietário não pode ficar em branco.',
  'Goals.CreateGoal.header': 'Criar meta',
  'Goals.CreateGoal.parent-goal-label': 'Meta pai',
  'Goals.CreateGoal.parent-goal.error': 'A meta pai não pode ficar em branco.',
  'Goals.CreateGoal.required-fields-are-marked':
    'Os campos obrigatórios estão marcados com um asterisco <asterisk></asterisk>',
  'Goals.CreateGoal.site-label': 'Site',
  'Goals.CreateGoal.type-label': 'Tipo',
  'Goals.CreateGoal.type-label-placeholder': 'Que nome a gente deve dar?',
  'Goals.GoalCreationModal.label.date-selection-placeholder': 'Selecione uma data',
  'Goals.GoalCreationModal.label.date-selection-title': 'Data-alvo',
  'Goals.GoalCreationModal.label.owner-picker-placeholder': 'Inserir pessoa',
  'Goals.GoalCreationModal.label.owner-selection-title': 'Proprietário',
  'townsquare.api.goal-type-description.goal': 'Metas gerais',
  'townsquare.api.goal-type-description.key-result': 'A forma quantitativa de medir um objetivo (estrutura OKR).',
  'townsquare.api.goal-type-description.objective': 'O resultado que você quer alcançar (estrutura OKR)',
};
